var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"id":"logo","alt":"PKI logo","src":require("./assets/logo.png")}}),_c('DownloadablePackages',{attrs:{"msg":"Remote Delivery PoC"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }